import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { AccountInfoLabel, BoxFlex, ClockIcon } from '@woovi/ui';
import { convertToMoney } from '@woovi/utils';

import type { PaymentActiveCreditCard_charge$key } from './__generated__/PaymentActiveCreditCard_charge.graphql.ts';
import PaymentLinkAdditionalInfo from '../../paymentLink/PaymentLinkAdditionalInfo.tsx';
import PaymentLinkComment from '../../paymentLink/PaymentLinkComment.tsx';
// eslint-disable-next-line
import PaymentLinkPaymentTerm from '../../paymentLink/PaymentLinkPaymentTerm.tsx';
import PaymentLinkTransactionDetails from '../../PaymentLinkTransactionDetails.tsx';

import type { ReactNode } from 'react';

type PaymentLinkActiveProps = {
  charge: PaymentActiveCreditCard_charge$key;
};

const PaymentActiveCreditCard = (props: PaymentLinkActiveProps): ReactNode => {
  const { t } = useTranslation();
  const charge = useFragment<PaymentActiveCreditCard_charge$key>(
    graphql`
      fragment PaymentActiveCreditCard_charge on Charge {
        id
        brCode
        identifier
        company {
          nameFriendly
          logo {
            url(fitIn: true)
          }
          projectType
          taxID {
            taxID
          }
        }
        valueWithDiscount
        ...PaymentLinkComment_charge
        ...PaymentLinkPaymentTerm_charge
        ...PaymentLinkAdditionalInfo_charge
        ...PaymentLinkTransactionDetails_charge
      }
    `,
    props.charge,
  );

  return (
    <BoxFlex
      sx={{
        flexDirection: 'column',
        gap: '20px',
        mt: '20px',
      }}
    >
      <BoxFlex sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <ClockIcon />
      </BoxFlex>
      <Typography
        variant={'h2'}
        sx={{ fontSize: '22px', fontWeight: 'bold', textAlign: 'center' }}
      >
        {t('Awaiting Payment')}
      </Typography>
      <PaymentLinkComment charge={charge} />

      <AccountInfoLabel
        label={t('Value')}
        text={convertToMoney(charge.valueWithDiscount)}
      />
      <BoxFlex
        sx={{
          flexDirection: 'column',
        }}
      >
        {/*<PaymentLinkPaymentTerm charge={charge} />*/}
        <PaymentLinkTransactionDetails charge={charge} />
        <PaymentLinkAdditionalInfo charge={charge} />
      </BoxFlex>
    </BoxFlex>
  );
};

export default PaymentActiveCreditCard;
